<template>
  <div class="content">
    <loading v-if="loading" text='Loading. Please wait...'/>
    <div v-show="!loading">
      <h1>Upcoming events</h1>
      <span v-show="error" class="help is-danger">{{error}}</span>
      <div v-if="Object.keys(mappedEvents).length === 0" class="no-content-message">
        There are currently no events to display.
      </div>
      <div v-for="(events, i) in mappedEvents" v-bind:key="i" class="day">
        <div class="date-divider">{{moment(i).format("ddd, D MMMM YYYY")}}</div>
        <div v-for="(event, j) in events" v-bind:key="'event'+j" class="calendar-event list-item">
          <div class="times" v-html="formatTime(event)"></div>
          <div class="calendar-title" :style="{'border-color': utils.stringToBgRGBAColor(event.tags[0])}">
            <div class="calendar-event-title">{{utils.truncateString(event.title, 300)}}</div>
            <Popover v-if="event.desc || event.location" class="details" placement="right" :width="470">
              <span @click=";" class="no-select">
                <span class="details-button">See details</span>
              </span>
              <div slot="content">
                <div class="details-wrapper">
                  <div v-if="event.desc" class="tr">
                    <div class="info-title">Description:</div>
                    <div class="info-value">{{event.desc}}</div>
                  </div>
                  <div v-if="event.location" class="tr">
                    <div class="info-title">Location:</div>
                    <div class="info-value">{{event.location}}</div>
                  </div>
                </div>
              </div>
            </Popover>
          </div>
          <div class="calendar-name" v-for="(tag, k) in event.tags" v-bind:key="k" :style="{color: utils.stringToBgRGBAColor(tag)}">
            {{tag}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');
  
  import Vue from 'vue';
  import utils from '@/utils/utils.js';
  import userUtils from '@/utils/userUtils.js';
  import error from '@/utils/error.js';
  import analytics from '@/utils/analytics.js';
  import { throws } from 'assert';
  import Popover from '@/components/widgets/popover';
  import storeHelpers from "@/utils/storeHelpers.js";
  
  export default {
    name: 'Calendar',
    components: {
      Popover
    },
    data: function () {
      var t = this;

      return {
       loading: true,
       mappedEvents: [],
       moment: moment,
       utils: utils,
       error: ''
      }
    },
    mounted: function () {
      storeHelpers.checkActive(this);
      analytics.upcomingEvents(this);
      userUtils.checkAuth(this, this.getCalendar); 
    },
    methods: {
      getCalendar: function (username) {
        var t = this;
        t.loading = true;

        const from = moment().startOf('day').unix();
        const to = moment().add(2,'month').endOf('day').unix();
        
        var url = this.$config.get('ecApi') + "web/calendar?start="+from+"&end="+to;

        axios.get(url).then(response => {
          var data = response.data

          t.mappedEvents = _.groupBy(data, event => moment(event.start*1000).format("YYYYMMDD"));
        
          t.loading = false;
        })
        .catch(e => {
            error.check401And498(t, e);
            t.loading = false;
            t.error = error.logAndGetError(t, e);
        })
      },
      formatTime: function(event) {
        var start = moment(event.start*1000).format("HH:mm");
        var end = moment(event.end*1000).format("HH:mm");

        if (event.allDay) {
          return "<b>All day</b>";
        }
        
        return "<b>" + start + "</b><br>" + end;
      }
    }
  }

</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.calendar {
  position: absolute;
  right: 10px;
  top: 0px;
}

.day {
  text-align: left;
}

.calendar-event {
  display: table;
  width: 100%;
  position: relative;
  padding: 0 !important;
  cursor: default !important;

  .times {
    display: table-cell;
    padding: 10px;
    width: 100px;
    display: inline-block;
    font-weight: normal;
    text-align: center;

    // border: 1px solid black;
  } 

  .calendar-title {
    display: table-cell;
    padding: 10px;
    width: 70%;
    font-weight: bold;
    padding-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    border-left: 2px solid $border-color;
    vertical-align: top;
    // border: 1px solid black;
  }

  .calendar-name {
    display: table-cell;
    padding: 10px;
    text-align: right;
    width: 20%;
    vertical-align: top;
    font-weight: normal;

    // border: 1px solid black;
  }
}

.details-button {
  font-weight: normal;
  color: $primary-color;
  font-size: 11pt;
  cursor: pointer;
}

.details-button:hover {
  color: $primary-color-hover;
}

.details-wrapper {
  display: table;
  // width: 100%;
  .tr {
    display: table-row;
    .info-title {
      display: table-cell;
      // border: 1px solid black;
      font-weight: bold;
    }
    .info-value {
      display: table-cell;
      padding: 10px;
      // border: 1px solid black;
    }
  }
}
</style>